import React from 'react'
import type { TF } from '../types'
import { type OhlcvRow } from '../services/candlesService'
import { fetchCandlesLive } from '../services/candlesLiveService'

export function useCandles(symbol: string, timeframe: TF, limit = 500, refreshKey?: any) {
  const [data, setData] = React.useState<OhlcvRow[] | null>(null)
  const [loading, setLoading] = React.useState(false)
  const [error, setError] = React.useState<string | null>(null)

  React.useEffect(() => {
    let cancelled = false
    const controller = new AbortController()
    async function run() {
      try {
        setLoading(true)
        setError(null)
        setData(null)
        const rows = await fetchCandlesLive({ symbol, timeframe, limit })
        if (!cancelled) setData(rows)
      } catch (e: any) {
        if (!cancelled) setError(e?.message || 'Falha ao carregar candles')
      } finally {
        if (!cancelled) setLoading(false)
      }
    }
    if (symbol && timeframe) run()
    return () => { cancelled = true; controller.abort() }
  }, [symbol, timeframe, limit, refreshKey])

  return { data, loading, error }
}
